import { render, staticRenderFns } from "./Create-Supplier.vue?vue&type=template&id=5b731dbe&scoped=true"
import script from "./Create-Supplier.vue?vue&type=script&lang=js"
export * from "./Create-Supplier.vue?vue&type=script&lang=js"
import style0 from "./Create-Supplier.vue?vue&type=style&index=0&id=5b731dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b731dbe",
  null
  
)

export default component.exports